export default {
      id: "triangle-usage",
      viewBox: "0 0 9 6",
      url: __webpack_public_path__ + "sprite.svg#triangle",
      toString: function () {
        return this.url;
      }
    }